import { AnyAction } from 'redux';
import { Store } from 'store/index';
import { ThunkDispatch } from 'redux-thunk';
import { setPricesToFetchAction } from 'store/price/slice';
import { cloneDeep } from 'lodash';
import getPricesToFetch from '../selector/getPricesToFetch';
import { PricesToFetch } from '../types';

const removeFromPricesToFetchOperation =
  (categoryId: number, productIds: number[]) =>
  (dispatch: ThunkDispatch<Store, undefined, AnyAction>, getState: () => Store) => {
    const store = getState();
    let updatedPricesToFetch = cloneDeep(getPricesToFetch(store)) as PricesToFetch | undefined;
    if (!updatedPricesToFetch || !updatedPricesToFetch[categoryId]) {
      return;
    }
    updatedPricesToFetch[categoryId].productIds = updatedPricesToFetch[categoryId].productIds.filter(
      (productId) => productIds.indexOf(productId) === -1,
    );
    if (updatedPricesToFetch[categoryId].productIds.length === 0) {
      delete updatedPricesToFetch[categoryId];
    }
    if (Object.keys(updatedPricesToFetch).length === 0) {
      updatedPricesToFetch = undefined;
    }
    dispatch(setPricesToFetchAction(updatedPricesToFetch));
  };

export default removeFromPricesToFetchOperation;
